export default "__VITE_ASSET__DA_A2hP2__"